import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import { formatApiError } from "../lib/api";

const Auth = ({ mode = "login" }) => {
  const { login, register } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const isLogin = mode === "login";
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (isLogin) {
        await login(form.email, form.password);
      } else {
        await register({ name: form.name, email: form.email, phone: form.phone, password: form.password });
      }
      navigate("/account");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full border border-brand-line bg-white px-4 py-3 text-sm outline-none focus:border-brand-ink transition-colors";
  const labelCls = "overline block mb-2";

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="auth-page">
      <h1 className="font-serif font-light text-4xl tracking-tight text-center mb-2">
        {isLogin ? t("login") : t("register")}
      </h1>
      <p className="text-center overline mb-10">Sparkle</p>

      <form onSubmit={submit} className="space-y-5">
        {!isLogin && (
          <>
            <div>
              <label className={labelCls}>{t("full_name")}</label>
              <input className={field} value={form.name} onChange={set("name")} required data-testid="auth-name" />
            </div>
            <div>
              <label className={labelCls}>{t("phone")}</label>
              <input className={field} value={form.phone} onChange={set("phone")} data-testid="auth-phone" placeholder="+994" />
            </div>
          </>
        )}
        <div>
          <label className={labelCls}>Email</label>
          <input type="email" className={field} value={form.email} onChange={set("email")} required data-testid="auth-email" />
        </div>
        <div>
          <label className={labelCls}>{t("password")}</label>
          <input type="password" className={field} value={form.password} onChange={set("password")} required data-testid="auth-password" />
        </div>
        <button type="submit" disabled={loading} data-testid="auth-submit" className="w-full bg-brand-ink text-white py-4 text-sm tracking-[0.15em] uppercase hover:bg-brand-oxid transition-colors disabled:opacity-50">
          {loading ? t("loading") : isLogin ? t("login") : t("register")}
        </button>
      </form>

      <p className="text-center text-sm text-brand-sub mt-8">
        {isLogin ? t("no_account") : t("have_account")}{" "}
        <Link to={isLogin ? "/register" : "/login"} className="text-brand-ink underline underline-offset-4" data-testid="auth-switch">
          {isLogin ? t("register") : t("login")}
        </Link>
      </p>
    </div>
  );
};

export default Auth;
